export const productInventoryByTypeQuery = `query MyQuery($product_type: String!) {
    productInventoryByType(product_type: $product_type) {
      items {
        product_id
        product_type
        inventory {
          id: admin_graphql_api_id
          inventory_quantity
          pre_order_inventory_quantity
          fulfillment_location
          product_id
          sku
          options {
            type
            value
          }
        }
      }
    }
  }
    `
